var
    /**
     * Reserved drawer system class list
     * @type {string[]}
     */
    DRAWER_SPECIFIC_CLASS_LIST = [
        'push-over', 'drawer-left', 'drawer-right', 'drawer-top', 'drawer-bottom', 'drawer-form-container'
    ],
    /**
     *
     * @type {jQuery}
     */
    $doc = $(window.document);

/**
 * Simple getter
 * @return {jQuery|HTMLElement}
 */
function getElement() {
    return $('body');
}

var scrollTop = 0;
$doc.on('show.bs.modal', function (e) {
    var element = getElement();
    var classList = $(e.target).attr('class').split(' ');

    classList.forEach(function (cssClass) {
        if (DRAWER_SPECIFIC_CLASS_LIST.indexOf(cssClass) > -1) {
            element.addClass(cssClass);
        }
    });
});

$doc.on('hide.bs.modal', function (e) {
    var element = getElement();
    element.removeClass(DRAWER_SPECIFIC_CLASS_LIST.join(' '));

    var $drawer = $(e.target);
    if ($drawer.hasClass('drawer-form-container') && element.css('position') === 'fixed') {
        element.css('position', '');
        element.scrollTop(scrollTop);
    }
});

$doc.on('shown.bs.modal', function (e) {
    var element = getElement();
    var $drawer = $(e.target);
    if ($drawer.hasClass('drawer-form-container') &&
        $drawer.find('.drawer-container.modal-dialog').width() == element.width()) {
        scrollTop = element.scrollTop();
        element.css('position', 'fixed');
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/jslib-edm-bootstrap/src/drawer/drawer.js
// module id = 398
// module chunks = 18